import logger from 'shared/services/logger'
import store from 'shared/store'
import OffCanvasContainer from 'views/containers/browser/OffCanvasContainer'
import hydrateWithHOCs from 'views/containers/browser/utils/hydrateWithHOCs'

export default ({ container, i18n }) => {
  logger.info('OffCanvas module loaded')

  const { OffCanvasContainerInitialState } = store.getComponentInitialState()
  const { userSession } = store.getState()

  hydrateWithHOCs({
    container,
    i18n,
  })(
    <OffCanvasContainer
      {...OffCanvasContainerInitialState}
      userData={userSession}
    />
  )
}
